import React, {useEffect, useState} from "react";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {apiGetZone} from "./Actions";
import {useSelector} from "react-redux";
import ZoneTable from "./ZoneTable";
import {FiPlus} from "react-icons/fi";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";
import {EmptyState} from "../components/Table";

const Zone = () => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetZone(user.activeAreal.id, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání zón nastala chyba.");
            setLoading(false);
        });
    };

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám zóny..."}/>;
        if (!loading && data) return <ZoneTable data={data} setData={setData}/>;
        else return <EmptyState/>;
    };

    return (
        <>
            {user.activeAreal && (
                <>
                    <PageHeader crumbs={[{label: "Zóny"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton link="/zone/add" text="PŘIDAT ZÓNU" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {_renderBody()}
                </>
            )}
        </>
    );
};

export default Zone;
